export const CART_LOADING = 'CART_LOADING';
export const SAVE_CART_ITEMS = 'SAVE_CART_ITEMS';
export const ADD_TO_CART = 'ADD_TO_CART';
export const DELETE_FROM_CART = 'DELETE_FROM_CART';
export const DELETE_ALL_FROM_CART = 'DELETE_ALL_FROM_CART';